export default __webpack_public_path__ + "static/media/june_brundell.911a8363.jpg";